import React from 'react';
import ConditionalAddToCartButton from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/ConditionalAddToCartButton';
import { OfferCardFooterProps, OfferCardFooterType } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter.selectors';
import BookButtonContainer, { BookButtonState } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/BookButtonContainer';

interface ButtonGroupProps extends OfferCardFooterProps {
    isShowNotification: boolean;
    onOptionSelected: (e: React.MouseEvent) => void;
    onUpdateSelected: (e: React.MouseEvent) => void;
}

const ButtonGroup: React.FC<ButtonGroupProps> = React.memo(
    ({
        bookingFormUrl,
        onOptionSelected,
        onUpdateSelected,
        isCartEligible,
        isSearchCriteriaUpdated,
        isShowNotification,
        isLoading,
        isDesktop,
        isDetailRevampEnabled,
        footerType,
        isButtonDisabled,
        hasOnlyDisabledOptions,
        offerTitle,
        offerIndex,
        bookButtonState: bookButtonStateFromSelector,
        isDetailPageRefactor,
    }) => {
        const shouldShowBookButtonBeforeAddToCart = isDesktop && isDetailRevampEnabled && footerType === OfferCardFooterType.SummaryCard;
        const oldBookButtonState = isButtonDisabled && !isShowNotification ? BookButtonState.Disabled : isLoading ? BookButtonState.Loading : BookButtonState.Enabled;
        const bookButtonState = isDetailPageRefactor ? bookButtonStateFromSelector : oldBookButtonState;
        const shouldFocusOnBookButton = React.useRef<boolean>(false);
        const bookButtonRef = React.useRef<HTMLButtonElement | null>(null);
        const isBoxedFooterType = footerType === OfferCardFooterType.Boxed;
        const isSummaryCardType = footerType === OfferCardFooterType.SummaryCard;
        const buttonWidth = isBoxedFooterType ? 'content-fit' : 'parent-fit';
        React.useEffect(() => {
            if (bookButtonState === BookButtonState.Enabled && bookButtonRef.current && shouldFocusOnBookButton.current) {
                shouldFocusOnBookButton.current = false;
                bookButtonRef.current.focus();
            }
        }, [isLoading, bookButtonState]);
        return (
            <>
                {!shouldShowBookButtonBeforeAddToCart && (
                    <ConditionalAddToCartButton
                        isCartEligible={isCartEligible}
                        isSearchCriteriaUpdated={isSearchCriteriaUpdated}
                        width={buttonWidth}
                        hasOnlyDisabledOptions={hasOnlyDisabledOptions}
                        bookButtonState={bookButtonState}
                    />
                )}
                <BookButtonContainer
                    isSearchCriteriaUpdated={isSearchCriteriaUpdated}
                    handleUpdateSelected={onUpdateSelected}
                    handleOptionSelected={onOptionSelected}
                    bookButtonState={bookButtonState}
                    offerTitle={offerTitle}
                    isMarginRequired={isCartEligible && !isSummaryCardType}
                    width={buttonWidth}
                    bookButtonRef={bookButtonRef}
                    bookingFormUrl={bookingFormUrl}
                    offerIndex={offerIndex}
                />
                {shouldShowBookButtonBeforeAddToCart && (
                    <ConditionalAddToCartButton
                        isCartEligible={isCartEligible}
                        isSearchCriteriaUpdated={isSearchCriteriaUpdated}
                        width={buttonWidth}
                        hasOnlyDisabledOptions={hasOnlyDisabledOptions}
                        bookButtonState={bookButtonState}
                    />
                )}
            </>
        );
    },
);

ButtonGroup.displayName = 'CTAButtonGroup';

export default ButtonGroup;
